import { ListTodo, MessageSquare, Phone, type LucideIcon } from 'lucide-react';
import type { TaskType } from '@/types/task';

/**
 * The kinds of work a task can be — To-do (the default), Call or Message.
 * The type decides which action the task leads with, never how it is
 * billed: a task is the thing you do for a customer WITHOUT opening a job.
 * Going on site is a visit, which the schedule already handles.
 */
export const TASK_TYPE_OPTIONS: { value: TaskType; label: string; icon: LucideIcon }[] = [
  { value: 'TODO', label: 'To-do', icon: ListTodo },
  { value: 'CALL', label: 'Call', icon: Phone },
  { value: 'MESSAGE', label: 'Message', icon: MessageSquare },
];

export function taskTypeOption(type: TaskType | null | undefined) {
  return TASK_TYPE_OPTIONS.find((option) => option.value === type) ?? TASK_TYPE_OPTIONS[0];
}

/** Durations offered for a timed task; the block it takes on the calendar. */
export const TASK_DURATION_OPTIONS = [
  { value: '', label: 'No duration' },
  { value: '15', label: '15 min' },
  { value: '30', label: '30 min' },
  { value: '45', label: '45 min' },
  { value: '60', label: '1 hour' },
  { value: '90', label: '1.5 hours' },
  { value: '120', label: '2 hours' },
];

/** When to remind the assignee, as minutes before the due time. */
export const TASK_REMINDER_OPTIONS = [
  { value: 'none', label: 'No reminder' },
  { value: '0', label: 'At the due time' },
  { value: '15', label: '15 min before' },
  { value: '30', label: '30 min before' },
  { value: '60', label: '1 hour before' },
  { value: '1440', label: '1 day before' },
  { value: '2880', label: '2 days before' },
  // A week is the longest lead the API accepts (MAX_REMIND_MINUTES_BEFORE).
  { value: '10080', label: '1 week before' },
];

/** A reminder select value as the API field, and back. */
export function reminderToMinutes(value: string): number | null {
  return value === 'none' ? null : Number(value);
}
export function minutesToReminder(minutes: number | null | undefined): string {
  if (minutes === null) return 'none';
  return String(minutes ?? 0);
}
